module.exports = __webpack_public_path__ + "static/media/six_-monkeys.2ad672fa.png";